export const setRouteParam = (
    provinceCode: string,
    language: number,
    removeOrgGuidParam?: boolean
) => {
    const urlParameters = new URLSearchParams(window.location.search)
    const orgGuidFromUrl = urlParameters.get('og')?.toString()

    const baseurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname

    let orgGuidParam = ''
    if (orgGuidFromUrl && orgGuidFromUrl !== '') {
        orgGuidParam = '&og=' + orgGuidFromUrl
    }

    if (removeOrgGuidParam) {
        orgGuidParam = ''
    }

    const newurl =
        baseurl +
        '?prov=' +
        provinceCode +
        '&lang=' +
        language.toString() +
        orgGuidParam

    window.history.pushState({ path: newurl }, '', newurl)
}
